import React, { useState } from "react";
import Form from "react-bootstrap/Form";

const EventNoteRecorder = ({ handleChange }) => {
  const [enableNotes, setEnableNotes] = useState(false);
  const [notes, setNotes] = useState("");

  const handleNotesChange = (newNotes) => {
    setNotes(newNotes);
    handleChange(newNotes);
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setEnableNotes(checked);
    if (!checked) {
      setNotes("");
      handleChange("");
    }
  };

  return (
    <div className="top-spacer">
      <Form.Check
        type="checkbox"
        checked={enableNotes}
        label={"Add Notes"}
        onChange={handleCheckboxChange}
      />
      <Form.Group hidden={!enableNotes}>
        {/* <Form.Label>Notes</Form.Label> */}
        <Form.Control
          as="textarea"
          rows={2}
          placeholder="Notes or comments about this event"
          onChange={(e) => handleNotesChange(e.target.value)}
          value={notes}
        />
        <Form.Text className="text-muted">
          Notes or comments about this event
        </Form.Text>
      </Form.Group>
    </div>
  );
};

export default EventNoteRecorder;
